import Vue from 'vue';
import VueTippy, { TippyComponent } from 'vue-tippy';

// eslint-disable-next-line import/no-extraneous-dependencies
import 'tippy.js/themes/light.css';

Vue.use(VueTippy);
Vue.component('tippy', TippyComponent);
